export enum StatusColor {
    SUCCESS = 'success',
    WARNING = 'warning',
    LOW_ALERT = 'lowAlert',
    HIGH_ALERT = 'highAlert',
    INACTIVE = 'inactive',
    INFO = 'info',
}
